import { render, staticRenderFns } from "./StarShopGet.vue?vue&type=template&id=6b455687"
import script from "./StarShopGet.vue?vue&type=script&lang=js"
export * from "./StarShopGet.vue?vue&type=script&lang=js"
import style0 from "./StarShopGet.vue?vue&type=style&index=0&id=6b455687&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports